module.exports = __webpack_public_path__ + "img/icon-hot.8de1b9f.webp";